import { action, observable } from 'mobx';

class MenuStore {
  @observable id = null;

  @observable anchorEl = null;

  @action.bound
  open(id, anchorEl) {
    this.id = id;
    this.anchorEl = anchorEl;
  }

  @action.bound
  close() {
    this.id = null;
    this.anchorEl = null;
  }

  isOpen(id) {
    const isOpen = this.id == id && this.anchorEl != null;
    return isOpen;
  }
}

export default new MenuStore();

export { MenuStore };
